<div class="not-found container">
  <img
    src="assets/img/broken-phone.svg"
    alt=""
    class="not-found__img"
  />
  <h1 class="title not-found__title">Oops, something went wrong</h1>
  <p class="not-found__desc">Page not found</p>
  <button [routerLink]="''" class="btn btn_soft btn_roboto not-found__btn">
    Get back
  </button>
</div>
